<div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0" [ngClass]="{'tw:mt-4': hideInternalControls}">

  @if (!hideInternalControls) {
    <div class="tw:w-full tw:p-0 tw:m-0 tw:mt-1 tw:mb-4 tw:flex">
      <div class="tw:relative tw:flex-1">
        <input class="form-control session-filter-input" placeholder="Filter session by Id, subject, year or client"
          type="text" (keyup)="filterSessions($event)" [(ngModel)]="sessionFilterText">
        @if (sessionFilterText) {
          <button type="button" class="session-filter-clear" (click)="clearSessionFilter()"
            matTooltipPosition="above" matTooltip="Clear filter" aria-label="Clear filter">&#10005;</button>
        }
      </div>
        <button class="btn btn-sm btn-primary tw:ml-2" type="button" (click)="togglePlacementFullscreenView()"
          matTooltipPosition="above" matTooltip="Show fullscreen">
          <div class="fullscreen-icon-white cursor-pointer"></div>
        </button>
      </div>
    }

    <div class="tw:w-full tw:p-0 tw:m-0">
      <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0"
        [ngClass]="{'main-overview-container': !hideInternalControls}">

        @if (sessionOverviewHelper.sessions.length > 0) {
          <div class="tw:w-full tw:p-0 tw:m-0">
            <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0">
              @for (session of sessionOverviewHelper.sessions | paginate: { id: 'sessionPagination', itemsPerPage: sessionItemsPerPage, currentPage: sessionPaginatorPage }; track session; let i = $index) {
                <div class="tw:w-full tw:p-0 tw:m-0 tw:my-4 session-item-container"
                  >
                  <div class="session-item tw:py-4">
                    <!-- (click)="setAssessment(assessment, confirmModal)"-->
                    <div class="tw:flex tw:flex-wrap tw:h-full">
                      @if (sessionOverviewHelper.mobileOverwrite) {
                        <div class="tw:w-full tw:px-[15px] tw:mb-2 tw:flex tw:justify-center tw:items-center"
                          >
                          <div class="btn-group-xs" role="group">
                            <button type="button" class="btn btn-group-item"
                              [ngClass]="{'active': session.showInfo}"
                            (click)="toggleSlider('info', session)">Info</button>
                            <button type="button" class="btn btn-group-item"
                              [ngClass]="{'active': session.showSessionSlider}"
                            (click)="toggleSlider('session', session)">Sessions</button>
                          </div>
                        </div>
                      }
                      @if (!sessionOverviewHelper.mobileOverwrite || session.showInfo) {
                        <div class="tw:w-full tw:md:w-[18.75%] tw:p-0 tw:m-0 tw:my-auto tw:sm:my-0 tw:pr-2 tw:flex tw:flex-col"
                          [ngClass]="{'tw:sm:w-1/4': !sessionOverviewHelper.mobileOverwrite, 'tw:xl:w-[12.5%]': hideInternalControls}">
                          <div class="tw:flex tw:flex-wrap tw:pr-4">
                            <div class="tw:w-full tw:px-1">
                              <label class="session-label tw:font-bold">{{session.clientName}}</label>
                            </div>
                            <div class="tw:w-full tw:px-1">
                              <label
                                class="session-label tw:font-bold">{{themeService.siteContent.placementIdLabel}}
                              {{session.bookingId}}</label>
                            </div>
                          </div>
                          <div class="tw:flex tw:flex-wrap tw:pr-4">
                            <div class="tw:flex-1 tw:px-1">
                              <label class="session-sub-label ">{{session.startDate | date: 'dd MMM
                              yyyy'}} - {{session.endDate | date: 'dd MMM yyyy'}}</label>
                            </div>
                          </div>
                          <div class="tw:flex tw:flex-wrap tw:pr-4">
                            <div class="tw:flex-1 tw:px-1">
                              <label class="session-sub-label">{{session.yearGroup}} -
                              {{session.session}}</label>
                            </div>
                          </div>
                          <div class="tw:flex tw:flex-wrap tw:pr-4">
                            <div class="tw:flex-1 tw:px-1">
                              <label class="session-sub-label">Booking Places:
                              {{session.maxGroupSize}}</label>
                            </div>
                          </div>
                          <div class="tw:flex tw:flex-wrap tw:pr-4">
                            <div class="tw:flex-1 tw:px-1">
                              <label class="session-sub-label">Tutor:
                              {{session.tutorName}}</label>
                            </div>
                          </div>
                          <div class="tw:flex tw:flex-wrap tw:pr-4">
                            <div class="tw:flex-1 tw:px-1">
                              <label class="session-sub-label">Learner:
                              {{session.studentDescription}}</label>
                            </div>
                          </div>
                          <div class="tw:flex tw:flex-wrap tw:pr-4 tw:grow">
                            <div class="tw:flex-1 tw:px-1 tw:py-1 tw:sm:py-0 tw:flex tw:sm:justify-start tw:justify-center tw:items-end btn-left-session-overview-report-container">
                              @if (tutorReportsViewPermission && !hideInternalControls) {
                                <button type="submit" class="btn btn-session-overview-reports"
                                  [disabled]="session.dotFlag > 0"
                                  (click)="navigatePlacement(session, 'reports')"
                                >Reports</button>
                              }
                              @if (bookingSetupViewPermission && !hideInternalControls) {
                                <button type="submit" class="btn btn-session-overview-reports"
                                  (click)="navigatePlacement(session, 'setup')"
                                >Setup</button>
                              }
                            </div>
                          </div>
                        </div>
                      }
                      @if (!sessionOverviewHelper.mobileOverwrite || !session.showInfo) {
                        <div class="tw:w-full tw:md:w-9/12 tw:p-0 tw:m-0 tw:pl-2 tw:grow tw:flex tw:flex-col"
                          [ngClass]="{'tw:sm:w-8/12': !sessionOverviewHelper.mobileOverwrite, 'tw:xl:w-10/12': hideInternalControls}">
                          <div class="tw:flex tw:flex-wrap tw:p-0 tw:mx-0 tw:mb-0 tw:mt-2 tw:grow">
                            <div class="tw:w-full tw:p-0 tw:m-0 tw:flex tw:flex-col"
                              [id]="'sessionSlider' + session.bookingId"
                              #sessionContainer>
                              @if (session.placementSessions.length > 0) {
                                <div class="tw:flex tw:flex-wrap tw:py-0 tw:px-1 session-slider-container tw:pt-2 tw:m-0 tw:grow tw:flex-col">
                                  <!-- tw:relative: the calendar's :host is position:absolute; without a positioned
                                       ancestor it anchors to the page shell and spills out of the tile (same fix
                                       as view-student-bookings). -->
                                  <div class="tw:w-full tw:p-2 tw:m-0 tw:flex tw:relative" #scrollMe style="overflow-x: auto; flex: 1; overflow-y: hidden;">
                                    <session-overview-session-calendar
                                      (blocksRenderComplete)="scrollRenderedBlocks($event, scrollMe)"
                                      [sessionCalendar]="session.sessionCalendar"
                                      [sessionContainer]="sessionContainer"
                                      [isExternal]="hideInternalControls"
                                      [wrapOnMonth]="hideInternalControls"
                                      [wrapWeeks]="false">
                                    </session-overview-session-calendar>
                                  </div>
                                </div>
                              }
                              @if (session.placementSessions.length == 0) {
                                <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0 session-slider-container">
                                  <div class="tw:w-full tw:px-[15px] tw:py-2">
                                    <label class="session-student-label">No sessions found for this
                                    {{themeService.siteContent.placementHeaderLabel.toLowerCase()}}</label>
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
              @if (sessionOverviewHelper.sessions.length > sessionItemsPerPage && !hideInternalControls) {
                <div class="tw:w-full tw:px-[15px]">
                  <div class="tw:flex tw:flex-wrap tw:items-center tw:p-0 tw:m-0">
                    <div class="tw:w-1/3 tw:p-0 tw:m-0 tw:flex tw:items-center">
                      <select [(ngModel)]="sessionItemsPerPage" (ngModelChange)="sessionPaginationTrigger(1)"
                        class="field__control pagination-items-per-dropdown">
                        <option [ngValue]="3">3</option>
                        <option [ngValue]="6">6</option>
                        <option [ngValue]="9">9</option>
                        <option [ngValue]="12">12</option>
                        <option [ngValue]="15">15</option>
                      </select>
                      <label class="tw:pl-2 tw:m-0 pagination-items-per-label">items per page</label>
                    </div>
                    <div class="tw:flex-1 tw:p-0 tw:m-0">
                      <!-- Shared new-style pager (matches the coordinator landing tiles) -->
                      <app-table-pagination
                        [page]="sessionPaginatorPage"
                        [pageSize]="sessionItemsPerPage"
                        [total]="sessionOverviewHelper.sessions.length"
                        (pageChange)="sessionPaginationTrigger($event)">
                      </app-table-pagination>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }

        @if (sessionOverviewHelper.sessions.length == 0) {
          <div class="tw:w-full tw:p-0 tw:m-0 tw:text-center">
            <h6>No sessions found.</h6>
          </div>
        }

      </div>
    </div>

  </div>